import { categories, navLinks, siteMeta } from "@/mocks/gossip";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="shell grid grid-cols-1 gap-10 py-12 md:py-16 lg:grid-cols-[1.4fr_1fr_1fr_1.1fr]">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg text-background-50">
              瓜
            </span>
            <strong className="font-heading text-lg tracking-wide text-background-50">{siteMeta.name}</strong>
          </div>
          <p className="mt-4 max-w-sm text-sm leading-7 text-background-200/80">{siteMeta.intro}</p>
          <a
            href={`mailto:${siteMeta.email}`}
            className="mt-5 inline-flex cursor-pointer items-center gap-2 text-sm text-background-100 transition-colors hover:text-accent-300"
          >
            <i className="ri-mail-line" aria-hidden="true" />
            {siteMeta.email}
          </a>
        </div>

        <nav aria-label="页脚导航">
          <h3 className="font-heading text-base text-background-50">快速导航</h3>
          <ul className="mt-4 space-y-3">
            {navLinks.map((item) => (
              <li key={item.href}>
                <a href={item.href} className="cursor-pointer text-sm text-background-200/80 transition-colors hover:text-background-50">
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="瓜料分类导航">
          <h3 className="font-heading text-base text-background-50">瓜料分类</h3>
          <ul className="mt-4 space-y-3">
            {categories.map((cat) => (
              <li key={cat.id}>
                <a href="#feed" className="cursor-pointer text-sm text-background-200/80 transition-colors hover:text-background-50">
                  {cat.name}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h3 className="font-heading text-base text-background-50">关于本站</h3>
          <p className="mt-4 text-sm leading-7 text-background-200/80">
            内容按「已确认 / 待核实」标注，投稿线索我们会尽快跟进。本站资讯仅供娱乐参考，请理性吃瓜。
          </p>
          <a href="#contact" className="btn-primary mt-5">
            <i className="ri-send-plane-line" aria-hidden="true" />
            前往投稿
          </a>
        </div>
      </div>

      <div className="border-t border-background-100/15">
        <div className="shell flex flex-col gap-2 py-5 text-xs text-background-200/70 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {siteMeta.name} · {siteMeta.slogan}</p>
          <p>内容仅供娱乐参考 · 请理性看待并注意甄别信息</p>
        </div>
      </div>
    </footer>
  );
}